<template>
	<div>
		<myheader headTitle="企业印章"></myheader>
		<div class="right all_height_line24 text14 textcolorwhite" @click="addSignetClick()">
			<img src="@/assets/images/add.svg" style="width:1.2rem;margin:.5rem;" />
		</div>
		<div class="all_list_main">
			<div class="all_list_content_nopadding">
				<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
					<div style="min-height: 90vh;height: auto;">
						<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
							v-show="list.length>0">
							<div v-for="(item,index) in list" :key="index" v-show="list.length>0">
								<div class="signetitem" @click="itemClick(item)">
									<span class="itemimg " >
										<img v-if="item.signetImg" class="backgroundC_white"
											:src="'data:image/png;base64,'+item.signetImg.signetFileBase64"
											style="width:3rem;heiht:3rem" />
									</span>
									<div class="itemcontent">
										<div class="text14 textcolorblack" style="margin-right: 1.5rem;">
											{{item.signetName}}
										</div>
										<div class="text12 textcolorblack margin_top_10">
											<span>
												{{item.signetTypeText}}
											</span>
											<span v-if="item.signetImg" style="margin-left: 2rem;" :class="{textcoloraaa:item.signetImg.signetImgStatus===1,
											textcolorAuth:item.signetImg.signetImgStatus===2,
											textcolorNopass:item.signetImg.signetImgStatus===3||item.signetImg.signetImgStatus===4}">
												{{item.signetImg.signetImgStatusText}}
											</span>
										</div>
										<!-- 	<div class="text12 textcolorblack margin_top_5">
											{{item.signetKind==='0'?'合同专用章':item.signetKind==='1'?'收货确认专用章':'交货确认专用章'}}
										</div> -->
									</div>
									<!-- 屏蔽编辑删除印模入口 -->
									<div class="itemtool" @click.stop="editItem(item)">
										<img src="@/assets/images/menu.svg" style="width:1rem;heiht:1rem" />
									</div>
								</div>
							</div>
						</van-list>
						<van-empty style="margin-top: 20vh;" description="暂无印章，请在企业认证时进行创建" v-show="list.length==0" />
					</div>
				</van-pull-refresh>
			</div>
		</div>
		<van-popup v-model:show="showBottom" position="bottom">
			<div class="bottomTool">
				<div class="horizontal_line"></div>
				<div class="bottomTooltext text14 textcolor999 backgroundC_white bwhite_ative" @click="editSignet()">
					{{editSignetText}}
				</div>
				<div class="horizontal_line"></div>
				<div class="bottomTooltext text14 textcolor999 backgroundC_white bwhite_ative" @click="delectSigtet()">
					删除印章</div>
				<div class="horizontal_line"></div>
				<div style="height:.5rem;background-color: #ededed;"></div>
				<div class="horizontal_line"></div>
				<div class="bottomTooltext all_height_line24 text14 textcolor999" @click="showBottom = false">
					取&nbsp;&nbsp;消</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
	import Vue from "vue";
	import {
		Empty,
		List,
		PullRefresh,
		Dialog
	} from "vant";
	export default {
		components: {
			[Empty.name]: Empty,
			[List.name]: List,
			[PullRefresh.name]: PullRefresh,
		},
		data() {
			return {
				//企业id
				corpId: null,
				//企业名称
				corpName: '',
				//企业编码
				creditCode: '',
				//是否下拉刷新
				refreshing: false,
				//印章列表数据
				list: [],
				loading: false,
				finished: false,
				//每页数量
				pageSize: 10,
				//第几页
				pageNum: 0,
				//是否显示底部弹窗
				showBottom: false,
				//缓存印章item
				signetitem: null,
				editSignetText: '替换印模图片',
			}
		},
		methods: {
			//添加印模
			addSignetClick() {
				this.$router.push({
					path: 'addsignet',
					query: {
						corpId: this.corpId,
					}
				})
			},
			//编辑跳转
			editSignet() {
				//this.$store.commit('changeSignetInfo', this.signetitem)
				this.$router.push({
					path: 'editsignet',
					query: {
						corpId: this.signetitem.corpId,
						signetId: this.signetitem.signetId,
						type: (this.signetitem.signetImg && this.signetitem.signetImg.signetFileBase64) ? 1 : 0
					}
				})
			},
			//跳转详情
			itemClick(item) {
				this.signetitem = item
				if (item.signetImg && item.signetImg.signetImgStatus === 2 || item.signetImg.signetImgStatus === 3) {
					this.$store.commit('changeSignetInfo', this.signetitem)
					this.$router.push({
						path: 'signetinfo',
						query: {
							corpId: item.corpId,
							signetId: item.signetId
						}
					})
				}
			},
			// 下拉刷新
			onRefresh() {
				//this.refreshing = true
				this.finished = false
				// 重新加载数据
				// 将 loading 设置为 true，表示处于加载状态
				this.loading = true
				this.onLoad()
			},
			//上拉加载
			onLoad() {
				// 清空列表数据
				if (this.refreshing) {
					this.list = [];
					this.refreshing = false;
				}
				this.getSignetList()
			},
			//删除印章
			delectSigtet() {
				var that = this
				this.showBottom = false
				if (!this.signetitem) {
					this.$Toast("删除失败！")
					return
				}
				Dialog.confirm({
						title: '提示',
						message: '确定删除当前印章？',
						confirmButtonText: '确定',
						confirmButtonColor: '#0277FC'
					})
					.then(() => {
						that.$store.dispatch(that.$LoadShow, true)
						that.$get("/corp/api/removeSignet", {
							signetId: that.signetitem.signetId
						}).then((res) => {
							that.$store.dispatch(that.$LoadShow, false)
							if (res.success) {
								that.getSignetList()
								that.$Toast("删除成功！")
							} else {
								that.$Toast(res.message || res.messageDetail || "删除失败！")
							}
						});
					})
					.catch(() => {
						// on cancel
					});
			},
			//弹窗
			editItem(item) {
				this.signetitem = item
				if (item.signetImg && item.signetImg.signetFileBase64) {
					this.editSignetText = '替换印模图片'
				} else {
					this.editSignetText = '添加印模图片'
				}
				this.showBottom = true
			},
			//获取电子印章列表/获取企业的印章列表
			getSignetList() {
				this.$store.dispatch(this.$LoadShow, true)
				this.$post("/corp/m/api/getCorpSignets?corpId=" + this.corpId, {})
					.then(res => {
						if (res.success && res.data) {
							this.list = res.data;
						} else {
							this.list = []
						}
						this.$store.dispatch(this.$LoadShow, false)
						this.loading = false
						this.finished = true
					}).catch(err => {
						this.$store.dispatch(this.$LoadShow, false)
						this.loading = false
						this.finished = true
					});
			},
			//初始化
			init() {
				this.corpId = this.$route.query.corpId
				this.corpName = this.$route.query.corpName
				this.creditCode = this.$route.query.creditCode
			}
		},
		mounted() {
			this.init()
			this.onRefresh()
		},
	}
</script>

<style scoped lang="scss">
	@import "../../styles/global.css";


	.right {
		position: fixed;
		top: 1.8rem;
		right: .5rem;
		z-index: 10;
	}

	.signetitem {
		margin: .8rem .5rem 0;
		background-color: white;
		padding: .8rem .5rem;
		border-radius: .3rem;
		position: relative;
		display: flex;

		.itemimg {
			display: inline-block;
			width: 3rem;
			heiht: 3rem
		}

		.itemcontent {
			display: inline-block;
			margin-left: .5rem;
		}

		.itemtool {
			position: absolute;
			top: .8rem;
			right: .5rem;
			width: 1rem;
			height: 1rem;
		}
	}
</style>

<!-- 印模类型（公章，合同章，人力资源章等）: 1 合同专用章 
2 收货确认专用章 
3 交货确认专用章  
4 企业公章   
5 人事专用章  
6  招标专用章  
7  非招标专用章 -->

<!-- signetImgStatus：图片审核状态 0-操作 1-审核中 2-已通过 3-不通过 4-已废弃 -->